import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 프로젝트 전체에 적용될 공통 스타일시트를 불러옵니다.
import './assets/css/main.css';

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
